import React from "react";
import "../pages/home.css";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div id="container">
      {/* ===== Expiry Marquee ===== */}
      <div className="style20">
        <div className="marquee">
          <p>मुद्दत समाप्ती : 10/11/2026    |    HelpLine Contact : 9975977462</p>
        </div>
      </div>

      {/* ===== Header ===== */}
      <header className="header">
        <h1 className="style1">ग्रामपंचायत कोतवालबर्डी</h1>
        <h1 className="style1">पंचायत समिती काटोल, जिल्हा परिषद नागपुर</h1>
        <h1 className="style1">महारष्ट्रातील एकमेव ग्रामपंचायत उपक्रम</h1>
      </header>

      {/* ===== Marquee ===== */}
      <div className="style20">
        <div className="marquee">
          <p>ग्रामपंचायत कोतवालबर्डी – तालुका काटोल – जिल्हा नागपूर</p>
        </div>
      </div>

      {/* ===== Main Menu ===== */}
      <nav className="menuicons">
        <ul>
          <li><Link to="/aboutus">About Us</Link></li>
          <li><Link to="/">मुखपृष्ठ</Link></li>
          <li><Link to="/gramsevakpage">ग्रामसेवक</Link></li>
         
          <li><Link to="/gallery">Gallery</Link></li>
          <li><Link to="/vikas">विकास कामे</Link></li>
          <li><Link to="/sabha">सभेची माहिती</Link></li>


        </ul>
      </nav>
      {/* ===== Sub Menu ===== */}
      <div className="menuicons">
        <ul>

         
          <li><Link to="/janmdakhala">जन्म दाखला</Link></li>
          <li><Link to="/death">मृत्यू दाखला</Link></li>
          <li><Link to="/vivah">विवाह दाखला</Link></li>
          <li><Link to="/gramsevak">ग्रामसेवक/ग्रा.वि.अ. कार्यकाल</Link></li>
          <li><Link to="/sarpanch">सरपंच कार्यकाल</Link></li>
          <li><Link to="/upsarpanch">उपसरपंच कार्यकाल</Link></li>
          <li><Link to="/sadasya">सदस्य कार्यकारणी</Link></li>

        </ul>
      </div>

      {/* ===== Main Section ===== */}
      <main>
        <h3 className="style2">
          ग्रामसेवक/ग्रा.वि.अ. कार्यकाल
        </h3>

        <div style={{ overflow: "auto", height: "300px" }}>
          <table>
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नाव</th>
                <th>पद</th>
                <th>मोबाइल नंबर</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["1", "श्री.कैलाश पांडुरंगजी महाकुलकर", "सरपंच", "9822041516"],
                ["2", "श्री. दादाराव पंढरीजी कोल्हे", "उपसरपंच", "8605148184"],
                ["3", "श्री. राजेंद्र जगन्नाथजी वानखेडे", "सदस्य", "8308412395"],
                ["4", "श्री.संजय एकनाथजी धोटे", "सदस्य", "8668696012"],
                ["5", "सौ. सारिका पांडुरंगजी निंबुडे", "सदस्य", "8766438764"],
                ["6", "सौ. दुर्गा पिलाजी हरबडे", "सदस्य", "9881437516"],
                ["7", "श्रीमती लक्ष्मी देवरावजी खंडाते", "सदस्य", "9850928938"],
                ["8", "सौ. ज्योति सुखदेवजी सोणवणे", "सदस्य", "9657703317"],
                ["9", "श्री. शुद्धोधन भोजराज भोतमांगे", "सचिव", "9764850450"],
              ].map((row, index) => (
                <tr className="EvenRowColor" key={index}>
                  {row.map((cell, i) => (
                    <td key={i}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      {/* ===== Footer Section ===== */}
      <footer className="footer-section">
        {/* Social Icons */}
        <ul className="social-icons">
          <li>
            <a href="https://www.facebook.com/share/14PnRGa7BV7/" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/Facebook_logo_(square).png`} alt="Facebook" />
            </a>
          </li>
          <li>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/Logo_of_Twitter.svg.png`} alt="Twitter" />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/kotwalbardi/?utm_source=qr&r=nametag" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/instagaram.webp`} alt="Instagram" />
            </a>
          </li>
          <li>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/youtube.png`} alt="YouTube" />
            </a>
          </li>
        </ul>


        {/* Footer Links */}
        <p className="footer-links">
          <Link to="/copyright">Copyright Policy</Link> |{" "}
          <Link to="/disclaimer">Disclaimer</Link> |{" "}
          <Link to="/privacy">Privacy Policy</Link> |{" "}
          <Link to="/contact">Contact Us</Link>
        </p>

        <p>
          Website Designed, Developed & Maintained by{" "}
          <b>Certnexus India Pvt. Ltd. Nagpur</b>.<br />
          Content provided by Grampanchayat Office, Government of Maharashtra.
        </p>

        <p>© 2025 Certnexus India Pvt. Ltd. Nagpur</p>

        {/* Footer Logos */}
        <div className="footer-logos">
          <div className="footer-logos">
            <a href="https://swachhbharatmission.ddws.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/swachh-bharat.png`} alt="Swachh Bharat" />
            </a>
            <a href="https://digitalindia.gov.in" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/digital-india-logo.png`} alt="Digital India" />
            </a>
            <a href="https://data.gov.in" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/data-gov-logo.png`} alt="Data Portal" />
            </a>
            <a href="https://www.india.gov.in" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/portal.jpg`} alt="National Portal" />
            </a>
            <a href="https://mygov.in" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/mygov.png`} alt="MyGov" />
            </a>
            <a href="https://www.meity.gov.in" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/Meity_logo.png`} alt="MeitY" />
            </a>
            <a href="https://pmindia.gov.in" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/pm-india-logo.jpg`} alt="PM India" />
            </a>
          </div>

        </div>
      </footer>
    </div>
  );
};

export default Home;
